import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

export const makePhoneCallTool = createTool({
  id: 'make-phone-call',
  description:
    'Initiate a phone call to a specified phone number. Use this when user wants to call a contact or when suggesting to make a call.',
  inputSchema: z.object({
    phoneNumber: z
      .string()
      .describe('Phone number to call (with country code if applicable)'),
    skipConfirmation: z
      .boolean()
      .describe(
        'If true, make the call immediately without asking for user confirmation'
      ),
  }),
  outputSchema: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  execute: async (context: any) => {
    const skipConfirmation = false
    const querySearch = {
      modal: 'phone',
      phoneModal: {
        phoneNumber: context.phoneNumber,
      },
    }

    store.dispatch(
      appActions.navigate({
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `${skipConfirmation ? 'Calling' : 'Preparing to call'} ${
        context.phoneNumber
      }`,
    }
  },
})
